class PoFaqWordlift extends HTMLElement {
    constructor() {
        super();
        this.handleCollection = '';
    }

    connectedCallback() {
        this.handleCollection = this.resolveCollectionHandle();
        this.fetchData();
    }

    resolveCollectionHandle() {
        const match = window.location.pathname.match(/\/collections\/([^/]+)/);
        if (match?.[1]) return decodeURIComponent(match[1]).trim();

        return this.getAttribute('data-handle-collection')?.trim() || '';
    }

    async fetchData() {
        this.handleCollection = this.resolveCollectionHandle();
        if (!this.handleCollection) return;
        try {
            const response = await fetch(`https://api.wordlift.io/data/https/${window.location.host}/en-us/collections/${this.handleCollection.trim()}`);
            await console.log(response);
            if (!response.ok) {
                throw new Error(`Errore HTTP: ${response.status}`);
            }
            const raw = await response.text();
            if (!raw || !raw.trim()) {
                console.warn('PoFaqWordlift.fetchData: Empty response body for handleCollection=', this.handleCollection);
                this.style.display = 'none';
                return;
            }

            let data;
            try {
                data = JSON.parse(raw);
            } catch (parseError) {
                console.error('PoFaqWordlift.fetchData: Invalid JSON response', {
                    handleCollection: this.handleCollection,
                    status: response.status,
                    bodyPreview: raw.slice(0, 300)
                });
                throw parseError;
            }

            if (!Array.isArray(data)) {
                console.warn('PoFaqWordlift.fetchData: Unexpected payload shape, expected array.');
                this.style.display = 'none';
                return;
            }

            //find mainEntity data
            const d = data.filter(i => {
                if (i.hasOwnProperty('mainEntity')) {
                    return i;
                }
            });

            if (!d[0] || !d[0].mainEntity) {
                console.warn('PlpFaqData.fetchData: No FAQs found for handleCollection=', this.handleCollection);
                this.style.display = 'none';
                return;
            }

            this.renderFaqs(d);
            this.insertJsonLd(d);

        } catch (error) {
            this.style.display = 'none';
            console.error('Errore nella fetch:', error);
        }
    }

    insertJsonLd(faqData) {
        if (!faqData?.[0]?.mainEntity) return;
        const script = document.createElement('script');
        script.type = 'application/ld+json';
        script.text = JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData[0].mainEntity || []
        });
        document.head.appendChild(script);
    }

    renderFaqs(faqData) {
        if (!faqData[0] || !faqData[0].mainEntity) return;
        const faqs = faqData[0].mainEntity;
        const accordions = Array.from(this.querySelectorAll('.tw-po-accordion'));

        accordions.forEach((accordion, i) => {
            const faq = faqs[i];
            const titleEl = accordion.querySelector('summary > span');
            const contentEl = accordion.querySelector('.po-accordion-content > div');
            const containerEl = accordion.closest('.faq-container');
            const rowEl = containerEl || accordion;
            const separatorEl = !containerEl ? accordion.nextElementSibling : null;

            if (!faq || !titleEl || !contentEl) {
                rowEl.classList.add('tw-hidden');
                if (separatorEl?.classList?.contains('tw-bg-po-tertiary')) {
                    separatorEl.classList.add('tw-hidden');
                }
                return;
            }

            titleEl.innerHTML = faq.name || '';
            contentEl.innerHTML = faq.acceptedAnswer?.text || '';

            if (contentEl.innerHTML.trim() === '') {
                rowEl.classList.add('tw-hidden');
                if (separatorEl?.classList?.contains('tw-bg-po-tertiary')) {
                    separatorEl.classList.add('tw-hidden');
                }
            }
        });
    }
}

if (!customElements.get('faq-wordlift-data')) {
    customElements.define('faq-wordlift-data', PoFaqWordlift);
}
